var render = function render(){var _vm=this,_c=_vm._self._c;return _c('zl-dialog',{ref:"dialog",staticClass:"zl-saas",attrs:{"title":"谈判详情"}},[_c('el-tabs',{attrs:{"value":"first"}},[_c('el-tab-pane',{attrs:{"label":"谈判报价","name":"first"}},[_c('tanPanBaoJia',{attrs:{"row":_vm.row}})],1),_c('el-tab-pane',{attrs:{"label":"谈判记录","name":"second"}},[_c('tanPanRecord',{attrs:{"row":_vm.row}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }